export const version = () => require("../package.json").version;
export { createFile } from "./core";
